import React from "react";
import * as Icons from "lucide-react";
import { SectionHeading, PillLink } from "../components/common";
import { GuideMascot } from "../components/GuideMascot";
import { PROGRAMS, GUIDES, PHOTOS } from "../data/content";

const Programs = () => {
  return (
    <div data-testid="programs-page">
      <section className="bg-[#FDFBF7] pt-14 pb-16">
        <div className="mx-auto max-w-5xl px-5 md:px-8 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1">
            <span className="font-hand text-2xl text-[#4A90E2]">Flexible & holistic</span>
            <h1 className="font-head font-700 tracking-tight text-4xl sm:text-5xl text-[#1E293B] mt-1">Programs We Offer</h1>
            <p className="mt-4 font-body text-lg text-[#475569] leading-relaxed">
              We offer flexible, holistic programs that support children and families through every stage of early learning and development — all rooted in our five pillars.
            </p>
          </div>
          <GuideMascot src={GUIDES.wave} size={150} ring="#FFD166" className="animate-floaty" />
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {PROGRAMS.map((p, i) => {
              const Icon = Icons[p.icon] || Icons.Star;
              const tints = ["#eaf2fc", "#eef4ef", "#fdf1e6", "#f4edff", "#fdeef1"];
              const tint = tints[i % tints.length];
              return (
                <div
                  key={p.title}
                  data-testid="program-card"
                  className="rounded-3xl p-7 border border-black/5 shadow-soft-sm hover:-translate-y-1.5 transition-transform duration-200"
                  style={{ background: tint }}
                >
                  <span className="w-12 h-12 rounded-2xl bg-white grid place-items-center text-[#4A90E2] shadow-soft-sm">
                    <Icon size={22} />
                  </span>
                  <h3 className="mt-4 font-head font-600 text-xl text-[#1E293B]">{p.title}</h3>
                  <p className="mt-2 font-body text-sm text-[#475569] leading-relaxed">{p.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-8 bg-white">
        <div className="mx-auto max-w-6xl px-5 md:px-8">
          <div className="rounded-[2.5rem] bg-[#eef4ef] p-10 md:p-14 grid md:grid-cols-2 gap-8 items-center shadow-soft-sm">
            <div>
              <h2 className="font-head font-700 text-3xl text-[#1E293B]">Family solutions & holistic care</h2>
              <p className="mt-4 font-body text-[#475569] leading-relaxed">
                Every program honors each child's natural curiosity, allowing learning to emerge through play, relationships, real-life experiences, and joyful discovery. We support the whole family, every step of the way.
              </p>
              <div className="mt-6"><PillLink to="/enroll" variant="sage" testid="programs-enroll-btn">Inquire About a Program</PillLink></div>
            </div>
            <img src={PHOTOS.gardening} alt="Children gardening together" className="w-full aspect-[4/3] object-cover blob-mask shadow-soft" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Programs;
